import React, { Component } from 'react';
import FAQArticleView from '../../src/views/components/FAQArticleView';
import FAQArticle from '../../src/models/FAQArticle';


type AppProps = {
  article: FAQArticle,
}


export default class App extends Component<AppProps> {

  public render() {
    return (
      <React.Fragment>
        {
          <FAQArticleView article={this.props.article} id="faqArticle_1" />
        }
      </React.Fragment>
    );
  }
}